import type { Resource } from '../../';
export const product_sizeChart_ages_infants: Resource = {"default":"0 - 2 Years"};
